import { Component, Input } from '@angular/core';


@Component({
  selector: 'app-empty-chart',
  templateUrl: './empty-chart.component.html',
  styleUrls: ['./empty-chart.component.scss'],
  imports: []
})

export class EmptyChartComponent {
  @Input() heading: string;
  @Input() description: string = 'Nothing to show yet';
  @Input() circle = false;
  @Input() additionalStyle: string;
}
